import React from 'react';
import PropTypes from 'prop-types';
import { CtaButtonText } from 'site-modules/shared/components/native-ad/native-ad-components/cta-button-text/cta-button-text';

export function CtaUI({ ctaURL, ctaTarget = null, adClickTrackingListener, cta }) {
  return (
    <a
      className="site-served-ad-link no-focus text-decoration-none"
      href={ctaURL}
      rel="noopener noreferrer"
      target={ctaTarget}
      onClick={adClickTrackingListener}
    >
      <span className="btn btn-sm btn-outline-blue-50 text-blue-50 py-0_25 px-0_5 px-md-0_5 size-16 fw-bold mt-0 d-block rounded-8">
        <CtaButtonText text={cta} hideOpenIcon />
      </span>
    </a>
  );
}
CtaUI.propTypes = {
  ctaURL: PropTypes.string.isRequired,
  ctaTarget: PropTypes.string,
  adClickTrackingListener: PropTypes.func.isRequired,
  cta: PropTypes.string.isRequired,
};
